export const projectType = {
  defaultProject: 1,
  fundingProject: 2,
  defaultClass: 3,
};
